<template>
  <div>
    <div v-if="post.diffusions && post.diffusions.length > 0 && checkNbDiffusionsEnvoyees(post) > 0">
      <el-row v-for="diffusion in post.diffusions" :key="diffusion.id">
        <el-col v-if="diffusion.firstSentAt !== null && diffusion.envoyee === true && !diffusion.ordreSuppressionEnvoye" :lg="24">
          <el-col v-for="(icon, index) in icons" :key="index">
            <img v-if="diffusion.advertiserPublication.portal.code.split('_')[0] === icon.name" :src="icon.picture" :width="icon.width" :alt="icon.attribute"/>
          </el-col>
        </el-col>
        <el-col v-else-if="diffusion.firstSentAt === null && diffusion.envoyee === true && !diffusion.ordreSuppressionEnvoye" :lg="24">
          <el-col v-for="(icon, index) in icons" :key="index">
            <img v-if="diffusion.advertiserPublication.portal.code.split('_')[0] === icon.name" :src="icon.picture" :width="icon.width" :alt="icon.attribute"/>
          </el-col>
        </el-col>
        <el-col v-else-if="diffusion.ordreSuppressionEnvoye" :lg="24">
          <el-col v-for="(icon, index) in icons" :key="index">
            <img v-if="diffusion.advertiserPublication.portal.code.split('_')[0] === icon.name" :src="icon.picture" :width="icon.width" :alt="icon.attribute"/>
          </el-col>
        </el-col>
      </el-row>
    </div>
    <div v-if="post.planifications && post.planifications.length > 0">
      <el-row v-for="planification in post.planifications" :key="planification.id">
        <el-col v-if="planification.scheduled && planification.scheduled.lastExecution === null && planification.scheduled.status === '1'" :lg="24" style="padding-right: 8px;">
          <el-col v-for="(icon, index) in icons" :key="index">
            <img v-if="planification.portails[0].code.split('_')[0] === icon.name" :src="icon.picture" :alt="icon.attribute" :width="icon.width" />
          </el-col>
        </el-col>
      </el-row>
    </div>
    <div v-if="post.etat === 'B'" style="color: red;">{{ (noDash)? '' : 'Brouillon' }}</div>
    <div v-else-if="!checkNbDiffusionsEnvoyees(post) > 0 && !(post.planifications && post.planifications.length > 0)">{{ (noDash)? '' : '-' }}</div>
  </div>
</template>

<script>

export default {
  name: 'SocialPostsListTablePresence',
  props: {
    post: {
      type: Object,
      required: true
    },
    noDash: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      icons: [
        { name: 'INSTAGRAM', attribute: 'Icone instagram', picture: [require('@/assets/2048px-Instagram_icon.png')], width: '20' },
        { name: 'FACEBOOK', attribute: 'Icone facebook', picture: [require('@/assets/facebook-logo-5-1.png')], width: '20' },
        { name: 'GOOGLE', attribute: 'Icone google', picture: [require('@/assets/google-logo-carre.png')], width: '20' },
        { name: 'LINKEDIN', attribute: 'Icone linkedin', picture: [require('@/assets/linkedin-logo.png')], width: '20' }
      ]
    }
  },
  methods: {
    checkNbDiffusionsEnvoyees (post) {
      const networks = ['Instagram', 'Facebook', 'Google', 'Linkedin']
      // Je n'ai pas pris en compte Méta, il suffira de le rajouter au tableau de tri
      const validDiffuseurNames = post.diffusions.filter(item =>
        networks.some(network => item.diffuseurName.includes(network))
      ).map(item => item.diffuseurName)
      let nbEnvoyees = 0
      if (post.diffusions.length > 0) {
        post.diffusions.forEach(function (diffusion) {
          if (diffusion.envoyee === true && validDiffuseurNames.includes(diffusion.diffuseurName)) {
            nbEnvoyees += 1
          }
        })
      }
      return nbEnvoyees
    }
  }
}

</script>

<style scoped>

</style>
